import { Alert, Stack, Text } from 'braid-design-system';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

const PendingAlert = () => {
  const { t } = useTranslations(translations);

  return (
    <Alert tone="caution">
      <Stack space="medium">
        <Text>
          {t(
            'Your ad is awaiting approval and will go live once the review process is complete.',
          )}
        </Text>
      </Stack>
    </Alert>
  );
};

export default PendingAlert;
